.radio-group{display:flex;flex-direction:row;margin:15px 0}.radio-group mat-radio-button{margin-right:auto}
/*# sourceMappingURL=pause-resume-oic-workflow-dialog.component-RAWQLIPA.css.map */
